// extracted by mini-css-extract-plugin
module.exports = {"TrashCan":"CollectionName_TrashCan__d7mjt"};